// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__eZ8Jo","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__21ACg"};